<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button icon="keyboard_backspace" @click="goBack">Back</vs-button>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
          <h3>Select Campaign Fields</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
      </vs-row>
      <form-wizard
        color="rgba(var(--vs-dark), 1)"
        :title="null"
        :subtitle="null"
        finishButtonText="Submit"
        @on-complete="formSubmitted"
        @on-change="getMandatorySelectedFields"
      >
        <tab-content
          title="Choose Campaign"
          class="mb-5 mt-10"
          :before-change="beforeTabSwitch"
        >
          <!-- tab 1 content -->
          <div class="vx-row mb-6" style="width:100%;">
            <div class="vx-col sm:w-1/6 w-full mb-6">
              <h5>Choose Campaign :</h5>
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-6">
              <CampaignAutocomplete
                :key="companySearchComponentKey"
                class="searchbox"
                :list="searchCampaign"
                :searchOn="'campaign'"
                @event-name="selectCampaign"
              ></CampaignAutocomplete>
              <span class="text-danger text-sm mt-5" v-show="campaign_required"
                >{{ campaign_required }}
              </span>
            </div>
          </div>
        </tab-content>

        <tab-content title="Core Fields" class="mb-5 mt-10">
          <!-- tab 3 content -->
          <div class="vx-row mb-6" style="width:100%;">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center">
              <div class="vx-col sm:w-1/2 w-full mb-6">
                <h5>Core Fields</h5>
              </div>
            </vs-col>
            <DualListBox
              :source="core_fields"
              :destination="selectedCoreFields"
              label="name"
              @onChangeList="onCoreFieldChangeList"
            />
          </div>
        </tab-content>
      
        <tab-content title="Master Fields" class="mb-5 mt-10">
          <!-- tab 3 content -->
          <div class="vx-row mb-6" style="width:100%;">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center">
              <div class="vx-col sm:w-1/2 w-full mb-6">
                <h5>Master Fields</h5>
              </div>
            </vs-col>
            <DualListBox
              :source="master_fields"
              :destination="selectedMasterFields"
              label="name"
              @onChangeList="onMasterFieldChangeList"
            />
          </div>
        </tab-content>

        <!-- tab 3 content -->
        <tab-content title="Primary Client Fields" class="mb-5 mt-10">
          <div class="vx-row mb-6" style="width:100%;">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center">
              <div class="vx-col sm:w-1/2 w-full mb-6">
                <h5>Primary Client Fields</h5>
              </div>
            </vs-col>
             <DualListBox
              :source="primary_client_fields"
              :destination="selectedClientFields"
              label="name"
              @onChangeList="onClientFieldChangeList"
            />
          </div>
        </tab-content>

        <!-- tab 4 content -->
        <tab-content title="Campaign Fields" class="mb-5 mt-10">
          <div class="vx-row mb-6" style="width:100%;">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center">
              <div class="vx-col sm:w-1/2 w-full mb-6">
                <h5>Campaign Fields</h5>
              </div>
            </vs-col>
             <DualListBox
              :source="campaign_fields"
              :destination="selectedCampaignFields"
              label="name"
              @onChangeList="onCampaignFieldChangeList"
            />
          </div>
        </tab-content>

        <!-- tab 5 content -->
        <tab-content title="Opportunity Fields" class="mb-5 mt-10" >
          <div class="vx-row mb-6" style="width:100%;">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center">
              <div class="vx-col sm:w-1/2 w-full mb-6">
                <h5>Opportunity Fields</h5>
              </div>
            </vs-col>
             <DualListBox
              :source="opportunity_fields"
              :destination="selectedOpportunityFields"
              label="name"
              @onChangeList="onOpportunityFieldChangeList"
            />
          </div>
        </tab-content>

        <!-- tab 5 content -->
        <tab-content title="Mandatory Fields" class="mb-5 mt-10">
          <!-- tab 3 content -->
          <div class="vx-row mb-6" style="width:100%;">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center">
              <div class="vx-col sm:w-1/2 w-full mb-6">
                <h5>Mandatory Fields</h5>
              </div>
            </vs-col>
            <DualListBox
              :source="mandatory_fields"
              :destination="selectedMandatoryFields"
              label="name"
              @onChangeList="onMandatoryFieldChangeList"
            />
          </div>
        </tab-content>
      </form-wizard>
    </vx-card>
  </div>
</template>

<script>
import Vue from "vue";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import axios from "@/axios.js";
import defineAbilitiesFor from "@/config/abilities";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
import DualListBox from "dual-listbox-vue";
import "dual-listbox-vue/dist/dual-listbox.css";

export default {
  data() {
    return {
      campaign_required: null,
      companySearchComponentKey: 0,
      selected_campaign: null,
      selectedMasterFields: [],
      selectedMandatoryFields: [],
      selectedCoreFields: [],
      selectedClientFields: [],
      selectedCampaignFields: [],
      campaign_fields: [],
      master_fields: [],
      core_fields: [],
      primary_client_fields: [],
      opportunity_fields: [],
      mandatory_fields: [],
      selectedOpportunityFields: [],
    };
  },
  watch: {
    selectedMasterFields: function(val) {
      console.log(val);
    }
  },
  methods: {
    getMandatorySelectedFields(){
  
      let self = this;
      this.mandatory_fields = this.selectedCoreFields.concat(this.selectedMasterFields, this.selectedClientFields, this.selectedCampaignFields, this.selectedOpportunityFields)

      self.mandatory_fields = self.mandatory_fields.filter(md => self.selectedMandatoryFields.every(fd => fd.name != md.name && fd.description != md.description));




    },
    formSubmitted() {
      this.addCoreFieldsToCampaign();
      this.$router.go(-1);

      // alert("Form submitted!");
    },
    addAccountCoreFieldsToCampaign() {
      let self = this;
      let coreAccountData = [];
      self.selectedAccountCoreFields.forEach(element => {
        let coreAccountObj = {};
        coreAccountObj.field_name = element;
        coreAccountObj.campaign_id = self.selected_campaign.id;
        coreAccountData.push(coreAccountObj);
      });
      self.$store
        .dispatch(
          "campaignsManagement/addAccountCoreFieldsToCampaign",
          coreAccountData
        )
        .then(res => {})
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    addContactCoreFieldsToCampaign() {
      let self = this;
      let coreContactData = [];
      self.selectedContactCoreFields.forEach(element => {
        let coreContactObj = {};
        coreContactObj.field_name = element;
        coreContactObj.campaign_id = self.selected_campaign.id;
        coreContactData.push(coreContactObj);
      });
      self.$store
        .dispatch(
          "campaignsManagement/addContactCoreFieldsToCampaign",
          coreContactData
        )
        .then(res => {})
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    goBack: function() {
      this.$router.go(-1);
    },
    beforeTabSwitch: function() {
      if (this.selected_campaign != null) {
        return true;
      } else {
        this.campaign_required = "Please select a campaign to proceed.";
        return false;
      }
    },
    onCoreFieldChangeList: function({ source, destination }) {
  this.core_fields = source;
  this.selectedCoreFields = destination;
},
    onMasterFieldChangeList: function({ source, destination }) {
      this.master_fields = source;
      this.selectedMasterFields = destination;
    },
    onClientFieldChangeList: function({ source, destination }) {
      this.primary_client_fields = source;
      this.selectedClientFields = destination;
    },
    onCampaignFieldChangeList: function({ source, destination }) {
      this.campaign_fields = source;
      this.selectedCampaignFields = destination;
    },
    onOpportunityFieldChangeList: function({ source, destination }) {
      this.opportunity_fields = source;
      this.selectedOpportunityFields = destination;
    },
    onMandatoryFieldChangeList: function({ source, destination }) {
  this.mandatory_fields = source;
  this.selectedMandatoryFields = destination;
},
acceptAlert() {
    let self = this

    this.$router.push({
        path:
          '/campaigns/edit-more-field/' +
          self.selected_campaign.id
      })

 
    },
    checkAlreadySelectedFields() {
      let self = this;
      let selected_campaign_id = self.selected_campaign.id;
      this.$store
        .dispatch(
          "campaignsManagement/checkAlreadySelectedFields",
          selected_campaign_id
        )
        .then(response => {
          let result = response.data
          if(result.length > 0){

            self.$vs.dialog({
        color: "primary",
        title: `Selected Campaign Fields`,
        text: "The fields have already been selected for this campaign. Do you want to edit the selected fields?",
        accept: self.acceptAlert
      });

     
          }

          console.log("campaign results" , result)
          
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = [];
            return;
          }
          console.error(err);
        });
    },
    getAllCoreFields() {
      let self = this;
      self.$store
        .dispatch("campaignsManagement/getAllCoreFields")
        .then(response => {
          self.core_fields = response.data;

        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getAllMasterFields() {
      let self = this;
      self.$store
        .dispatch("campaignsManagement/getAllMasterFields")
        .then(response => {
          self.master_fields = response.data;
          self.master_fields = self.master_fields.filter(ele => ele.sales_developer_access == true)

        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getPrimaryClientFields() {
      let self = this;
      let selected_campaign_id = self.selected_campaign.id;
      self.$store
        .dispatch(
          "campaignsManagement/fetchPrimaryClientFields",
          selected_campaign_id
        )
        .then(response => {
          self.primary_client_fields = response.data;
          self.primary_client_fields = self.primary_client_fields.filter(ele => ele.sales_developer_access == true)

        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = [];
            return;
          }
          console.error(err);
        });
    },
    getCampaignFields() {
      let self = this;
      let selected_campaign_id = self.selected_campaign.id;
      this.$store
        .dispatch(
          "campaignsManagement/fetchCampaignFields",
          selected_campaign_id
        )
        .then(response => {
          self.campaign_fields = response.data;
          self.campaign_fields = self.campaign_fields.filter(ele => ele.sales_developer_access == true)
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = [];
            return;
          }
          console.error(err);
        });
    },
    getOpportunityFields() {
      let self = this;
      let selected_campaign_id = self.selected_campaign.id;
      self.$store
        .dispatch(
          "campaignsManagement/fetchOpportunityFields",
          selected_campaign_id
        )
        .then(response => {

          console.log("OPP FIELDS" , response)
          self.opportunity_fields = response.data;
          // self.primary_client_fields = self.primary_client_fields.filter(ele => ele.sales_developer_access == true)

        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaignDescription = [];
            return;
          }
          console.error(err);
        });
    },
    addCoreFieldsToCampaign() {
  let self = this;
  let coreData = [];
  self.selectedCoreFields.forEach(element => {
    let coreObj = {};
    coreObj.core_field_id = element.id;
    coreObj.campaign_id = self.selected_campaign.id;
    coreData.push(coreObj);
  });

  self.$store
    .dispatch("campaignsManagement/addCoreFieldsToCampaign", coreData)
    .then(res => {
      self.addMasterFieldsToCampaign();
      console.log(res);
    })
    .catch(err => {
      console.log(err);

                   if (err.response.status === 401) {
        this.$router.replace("/login");
}
    });
},
    addMasterFieldsToCampaign() {
      let self = this;
      let masterData = [];
      self.selectedMasterFields.forEach(element => {
        let masterObj = {};
        masterObj.master_field_id = element.id;
        masterObj.campaign_id = self.selected_campaign.id;
        masterData.push(masterObj);
      });

      self.$store
        .dispatch("campaignsManagement/addMasterFieldsToCampaign", masterData)
        .then(res => {
          self.addClientFieldsToCampaign();
          console.log(res);
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    addClientFieldsToCampaign() {
      let self = this;
      let clientData = [];
      self.selectedClientFields.forEach(element => {
        let clientObj = {};
        clientObj.client_field_id = element.id;
        clientObj.campaign_id = self.selected_campaign.id;
        clientData.push(clientObj);
      });
      self.$store
        .dispatch("campaignsManagement/addClientFieldsToCampaign", clientData)
        .then(res => {
          this.addCampaignFieldsToCampaign();
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    addCampaignFieldsToCampaign() {
      let self = this;
      let campaignData = [];
      self.selectedCampaignFields.forEach(element => {
        let campaignObj = {};
        campaignObj.campaign_field_id = element.id;
        campaignObj.campaign_id = self.selected_campaign.id;
        campaignData.push(campaignObj);
      });
      self.$store
        .dispatch(
          "campaignsManagement/addCampaignFieldsToCampaign",
          campaignData
        )
        .then(res => {
          self.addOpportunityFieldsToCampaign()
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    addOpportunityFieldsToCampaign() {
      let self = this;
      let opportunityData = [];
      self.selectedOpportunityFields.forEach(element => {
        let opportunityObj = {};
        opportunityObj.opportunity_field_id = element.id;
        opportunityObj.campaign_id = self.selected_campaign.id;
        opportunityData.push(opportunityObj);
      });
      self.$store
        .dispatch(
          "campaignsManagement/addOpportunityFieldsToCampaign",
          opportunityData
        )
        .then(res => {


          self.addMandatoryFieldsToCampaign()
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    addMandatoryFieldsToCampaign() {
      let self = this;
      let mandatoryData = [];
      self.selectedMandatoryFields.forEach(element => {
        let mandatoryObj = {};
        mandatoryObj.mandatory_field_id = element.id;
        mandatoryObj.campaign_id = self.selected_campaign.id;
        mandatoryData.push(mandatoryObj);
      });

      self.$store
        .dispatch("campaignsManagement/addMandatoryFieldsToCampaign", mandatoryData)
        .then(res => {
          self.submitOverallCampaignFieldsWithCampaignId();
          console.log(res);
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    submitOverallCampaignFieldsWithCampaignId() {


      let self = this;
      let campaign_id = self.selected_campaign.id;
      self.$store
        .dispatch(
          "campaignsManagement/submitOverallCampaignFieldsWithCampaignId",
          campaign_id
        )
        .then(res => {
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    selectCampaign() {
      let self = this;
      self.selected_campaign =
        moduleCampaignManagement.selected_campaign_and_client;
      if (self.selected_campaign != null) {


      self.checkAlreadySelectedFields()

        this.campaign_required = null;
        this.getAllCoreFields();
        this.getAllMasterFields();
        this.getPrimaryClientFields();
        this.getCampaignFields();
        this.getOpportunityFields();
      }
    },
    searchCampaign(inputValue) {
      let filter = {};
      filter.search_term = inputValue;
      filter.user_role = this.user_role;
      filter.user_id = this.user_id;
      return this.$store
        .dispatch("campaignsManagement/searchCampaign", filter)
        .then(response => {
          if (response) {
            let data = moduleCampaignManagement.state.campaign;
            if (data) {
              let mappedArray = [];
              for (const property in data) {
                if (typeof data[property].campaign_name != "undefined") {
                  mappedArray.push({
                    id: data[property].id,
                    name:
                      data[property].campaign_name +
                      "  -   " +
                      data[property].campaign_code,
                    type: "campaign"
                  });
                }
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    }
  },
  mounted() {},
  created() {
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });

    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
  },
  components: {
    FormWizard,
    TabContent,
    CampaignAutocomplete,
    DualListBox
  }
};
</script>
<style>
.msl-search-list-input {
  margin-bottom: 10px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 0.7rem !important;
  font-size: 1rem !important;
  height: 50px;
}

.msl-searchable-list__item {
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 0.7rem !important;
  font-size: 1rem !important;
  height: 50px;
}
.msl-multi-select__actions {
  font-size: 25px;
}

.msl-multi-select {
  width: 100%;
}
</style>
